export default __webpack_public_path__ + "static/media/OpenSans-Medium.be793100.ttf";